import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function fetchDownloadFormats(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/download_formats/${assetId}`;
  const response = await get(requestUrl);
  return response;
}

export async function fetchDownloadFormat(assetId: string, key: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/download_formats/${assetId}/${key}`;
  const response = await get(requestUrl);
  return response;
}
